import { BaseHttpProvider } from "./base-http.provider"

import type { LanguageISO } from "@providers"

export class SubscriptionProvider extends BaseHttpProvider {
  async sendConfirmation(params: { email: string; lang: LanguageISO }) {
    const { email, lang } = params
    await this.execute({
      uri: "/subscription/subscribe",
      method: "POST",
      isHmacAuthorization: true,
      data: {
        email,
        lang,
      },
    })
  }
}
